export const drawerPosition = {
  bottom: 'bottom',
  left: 'left',
  full: 'full',
} as const satisfies Record<string, 'bottom' | 'left' | 'full'>

export const drawerContent = {
  list: 'list',
  detail: 'detail',
  searchForm: 'searchForm',
} as const satisfies Record<string, 'list' | 'detail' | 'searchForm'>

export type DrawerPosition =
  (typeof drawerPosition)[keyof typeof drawerPosition]

export type DrawerContent = (typeof drawerContent)[keyof typeof drawerContent]
